import CustomCard from '../../../../../components/CustomCard';
import CustomChip from '../../../../../components/CustomChip';
import React from 'react';

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 * @param className class style for the card container div (required)
 * @param click: click event triggered on the card (required)
 * @param background background color for CustomChip (required)
 * @param fontColor text color for CustomChip (required)
 * @param borderColor: border color for CustomChip (required)
 * @param legend: title/label for CustomChip (required)
 * @param icon: icon component (required)
 * @param titleCard: title displayed on the card (required)
 *
 */
const ProcessCard = (
    {
        className = 'col-12 col-md-6 px-0 pr-md-2 py-0',
        click = null, background, fontColor, borderColor, legend = '', icon, titleCard = ''
    }
) => {

    return (
        <div className={`${className}`}>
            <CustomCard
                classes="w-100 card-hover-primary-300-50 d-flex flex-column h-100"
                classCard={`card-border-8px`} classContent={"p-16px"}
                click={ click != null ? () => click()  : null }
            >
                <div className="d-flex flex-column gap-2">
                    <div className="d-flex justify-content-end">
                        <CustomChip
                            background={background}
                            fontColor={fontColor}
                            borderColor={borderColor}
                            legend={legend}
                        />
                    </div>
                    <div className="h-90px d-flex justify-content-center align-items-center text-center">
                        {icon}
                    </div>
                    <p className="fs-20-to-14 ibl-font-w-600 font-color-general-950 text-center">{titleCard}</p>
                </div>
            </CustomCard>
        </div>
    );

}

export default ProcessCard
